export const filter_default = {
  rent: {
    floorplans: [
      "1+1", "1+kk", "2+1", "2+kk", "3+1", "3+kk", "4+1", "4+kk",
      "5+1", "5+kk", "6+1", "6+kk", "dum", "pokoj", "garsonka"],
    price: {
      min: 10000,
      max: 132000,
      step: 500,
    },
    area: {
      min: 30,
      max: 200,
      step: 1,
    },
    ranges: {
      price: [
        [0, 15000],
        [15000, 25000],
        [25000, 35000],
        [35000, 60000],
        [60000, 120000],
      ],
      area: [
        [0, 30],
        [30, 50],
        [50, 70],
        [70, 100],
        [100, 200],
      ],
    },
  },
  buy: {
    floorplans: [
      "1+1", "1+kk", "2+1", "2+kk", "3+1", "3+kk", "4+1", "4+kk",
      "5+1", "5+kk", "6+1", "6+kk", "dum", "garsonka"],
    price: {
      min: 4000000,
      max: 40000000,
      step: 50000,
    },
    area: {
      min: 30,
      max: 242,
      step: 1,
    },
    ranges: {
      price: [
        [0, 7000000],
        [7000000, 10000000],
        [10000000, 15000000],
        [15000000, 20000000],
        [20000000, 40000000],
      ],
      area: [
        [0, 40],
        [40, 60],
        [60, 80],
        [80, 100],
        [100, 200],
      ],
    },
  },
  sources: [
    'bazos',
    'bezrealitky',
    'ceskereality',
    'expats',
    'idnes',
    'remax',
    'sreality',
    'ulovdomov',
  ],
  source_names: {
    'bazos': 'Bazo\u0161',
    'bezrealitky': 'Bezrealitky',
    'ceskereality': '\u010Cesk\u00e9Reality',
    'expats': 'Expats',
    'idnes': 'iDNES',
    'remax': 'RE/MAX',
    'sreality': 'Sreality',
    'ulovdomov': 'UlovDomov',
  }
}
